<script>
export default {
  name: "ScholarshipSideDialog",

  props: {
    visible: Boolean,
    positionDialog: {
      type: String,
      default: "left",
      validator: function (value) {
        return ['left', 'right'].includes(value)
      }
    },
    width: {
      type: String,
      default: "900px",
    },
    persistent: {
      type: Boolean,
      default: false,
    }
  },

  computed: {

    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },


    setPositionDialog() {
      if (this.positionDialog === "right") return "v-dialog-right";
      if (this.positionDialog === "left") return  "v-dialog-left"
    },

    setAnimationDialog() {
      if (this.positionDialog === "right") return "slide-x-reverse-transition";
      if (this.positionDialog === "left") return  "slide-x-transition"
    },

    resulNameClasses() {
      return `${this.setPositionDialog} rounded-xl`
    }
  }
}
</script>

<template>
  <v-dialog
    v-model="show"
    :content-class="resulNameClasses"
    :width="width"
    :transition="setAnimationDialog"
    :persistent="persistent"
  >
    <v-card class="fill-height rounded-xl">
      <slot>

      </slot>
    </v-card>
  </v-dialog>
</template>

<style scoped>
>>> .v-dialog-right {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height: 98vh;
  min-height: 98vh;
  overflow-y: auto;
  top: auto;
  right: 20px;
}

>>> .v-dialog-left {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height: 98vh;
  min-height: 98vh;
  overflow-y: auto;
  top: auto;
  right: 25px;
}
</style>